module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c15"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('strong', [_vm._v("c. 460 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("The Paradoxes of Motion")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Zeno of Elea")]), _vm._v(" (c. 490–c. 430 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Around 470 BCE, Parmenides astonished educated Greeks by arguing that reality is completely static. There is a conflict, he claimed, between logic and our senses. Our senses tell us that things move and change, but reason forces us to conclude that the very ideas of motion and change are self-contradictory. Since our senses can deceive us, we should trust our reason and conclude that reality consists of a single eternal, unchangeable, indestructible sphere that Parmenides calls the One.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As outlandish as this view seems, it attracted some brilliant defenders. One was Zeno of Elea, who accompanied Parmenides on a visit to Athens in 450 BCE. Zeno formulated a whole slew of arguments to show that Parmenides was right. Some arguments were designed to show that a plurality of objects is impossible, while others attacked the concept of empty space or the reliability of the senses. The most famous were various “paradoxes of motion,” which sought to prove that motion is an illusion. One of the best-known paradoxes is known as The Dichotomy, or The Race Course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It goes like this: A swift runner could never complete a short race. Why? Because to win a race one must get to the finish line. To get to the finish line, one must first travel half the distance to the line, then three-quarters of the distance, then five-sixths, etc. Any finite distance can be divided into an infinite number of segments. That means that no runner could reach the finish line without passing through an infinite number of points in a finite amount of time. But that is impossible, Zeno argued, so no runner could ever finish a race.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philosophers and mathematicians continue to debate Zeno’s paradoxes today. In the big picture, what is more important than the paradoxes themselves is the manner in which Zeno argued for them. Aristotle stated that Zeno invented the art of “dialectic.” By this he meant the type of argument strategy that was Socrates’s stock-in-trade, namely, bringing out hidden contradictions or absurdities in a person’s initial assertion. If Socrates did learn this technique from Zeno, then Zeno’s contribution to Western philosophy was huge.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img41"
    }
  }, [_c('em', [_vm._v("Runners emblazon a c. 530 BCE prize amphora from the Panathenaic Games, which were held for centuries in Athens for its citizens.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/41-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c13"
    }
  }, [_vm._v("Change Is Illusory (c. 470 BCE)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc0329a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c15.vue
// module id = 117
// module chunks = 0